import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";

const ReferralPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleCreateReferralLink = async () => {
    if (!email) {
      setError("Please enter a valid email address.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const functions = getFunctions();
      const createReferralLink = httpsCallable(functions, "createReferralLink");
      const result = await createReferralLink({ email });
      const { onboardingUrl } = result.data;
      window.location.href = onboardingUrl;
    } catch (err) {
      setError("An error occurred. Please try again later.");
      console.error("Error creating referral link:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container" style={{ maxWidth: "500px", margin: "50px auto", textAlign: "center" ,minHeight:"100vh"}}>
      <h1>Become a Referrer</h1>
      <p>
        Earn a 10% commission for each successful premium subscription you refer.
      </p>
      <p>
        Enter your email below to get your unique referral link. You'll be redirected to Stripe to set up your free account so we can pay you.
      </p>
      <div style={{ margin: "20px 0" }}>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your email address"
          style={{ padding: "10px", width: "80%", borderRadius: "5px", border: "1px solid #ccc" }}
        />
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <button onClick={handleCreateReferralLink} disabled={loading} className="pricing-button">
        {loading ? "Generating Link..." : "Get My Referral Link"}
      </button>
    </div>
  );
};

export default ReferralPage;